module.exports = __webpack_public_path__ + "img/wechatpay215x58.29583fb3.png";